/* eslint-disable max-lines */
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import P1 from '@base/P1/P1';
import H3 from '@base/H3/H3';
import ContentsTable from '@base/ContentsTable/ContentsTable';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import { Spacings } from '@styles/index';
import Layout from '@layout/index';
import LeftContainer from '@cont/CompanyDetails/LeftContainer';
import RightContainer from '@cont/CompanyDetails/RightContainer';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import Link from 'next/link';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
`;

const StyledH3 = styled(H3)`
  margin-bottom: ${Spacings.SPACING_6B};
  padding-top: 100px;
  margin-top: -100px;
`;

const Paragraph = styled(P1)`
  margin-bottom: ${Spacings.SPACING_4B};
  text-align: justify;
`;

const StyledParagraph = styled(Paragraph)`
  margin-bottom: ${Spacings.SPACING_4B};
  ol > li {
    margin-bottom: ${Spacings.SPACING_2B};
    &:first-of-type {
      margin-top: ${Spacings.SPACING_2B};
    }
  }
`;

const ListItem = ({ children }) => (
  <StyledParagraph as="li">{children}</StyledParagraph>
);

const tableData = [
  {
    label: 'A. Eligibility And Participation',
    id: 'eligibility_and_participation'
  },
  {
    label: 'B. Personal Information',
    id: 'personal_information'
  },
  {
    label: 'C. Consent And Waiver By Participants',
    id: 'consent_and_waiver_by_participants'
  },
  { label: 'D. Disclaimers', id: 'disclaimers' },
  {
    label: 'E. Miscellaneous',
    id: 'miscellaneous'
  },
  {
    label: 'F. Contact Us',
    id: 'contact_us'
  }
];

const RankPredictorTerms = () => {
  const router = useRouter();
  const { pathname } = router;

  return (
    <>
      <LeftContainer>
        <MenusNav data={menus} currentHref={pathname} />
      </LeftContainer>

      <RightContainer>
        <Wrapper>
          <div>
            <div>
              <H2 as="h1">Unacademy State CETs Launch Terms and Conditions</H2>
            </div>
            <br />
            <br />
            <ContentsTable data={tableData} />
            <Paragraph>
              M/s SORTING HAT TECHNOLOGIES PRIVATE LIMITED (hereinafter referred
              to as “<b>Unacademy</b>”) plans to launch test preparation goals
              for the State CETs examinations, on Unacademy’s website
              www.unacademy.com and/or its mobile applications (
              <b>“Platform”/ “Unacademy Platform”</b>) (“<b>Goal(s)</b>”). Prior
              to the launch of the Goals, Unacademy is introducing an
              opportunity for individuals who are interested in subscribing to
              the prospective Goal(s) to pre-register to the relevant Goal(s)
              and subscribe to the respective Goal(s) at a discounted price
              during the launch, as provided herein (“<b>Program</b>”).
            </Paragraph>
            <Paragraph>
              The Program shall be made available to existing learners on the
              Platform, as well as any individual(s) who are interested in
              pre-booking their subscription(s) to the prospective Goal(s),
              subject to the terms specified below (“<b>Program Terms</b>”)
              along with the Unacademy{' '}
              <Link href="/terms">Terms and Conditions</Link>,{' '}
              <Link href="privacy">Privacy Policy</Link> and any other policies
              and guidelines made available on the Platform (“
              <b>Platform Terms</b>”). (collectively referred to as “
              <b>Terms</b>”)
            </Paragraph>
            <Paragraph>
              Registration is the first step in this Program. Accordingly, any
              learner or individual who registers for the Program and meets the
              eligibility criteria provided in the Terms shall be deemed to be a
              “<b>Participant</b>” of the Program and by registering for the
              Program, the Participants agree to have read and understood all
              the Terms.
            </Paragraph>
            <Paragraph>
              These Program Terms and conditions are an electronic record in
              terms of the Information Technology Act, 2000, the Information
              Technology (Amendment) Act, 2008, and other such applicable laws
              and regulations applicable to electronic records, as
              introduced/amended from time to time. These Terms form a legally
              binding agreement between the Participant and Unacademy i. By
              clicking on the ‘I agree’ icon or by submitting the registration
              form for participating in the Program, the Participant hereby
              unconditionally consent, agree, and undertake to be bound by these
              Terms, The Terms are subject to modification by Unacademy at its
              sole discreation, and Unacademy reserves the right to, at its sole
              discretion may revise, modify, cancel the Program at any point in
              time.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[0].id}>
              <StyledH3>{tableData[0].label}</StyledH3>
            </a>
            <Paragraph>
              All sign-up/registration forms must be submitted directly by the
              Participants and where the Participants do not fulfil the{' '}
              <Link href="/terms">Age Requirements</Link>, then such sign
              ups/registrations should be done with the consent of and under the
              supervision of their parent or legal guardian in accordance with
              the Terms.
              <br />
              <br />
              To participate in the Program, Participants will be required to
              follow the registration process that shall be communicated to them
              either via email sent by Unacademy and/or shall be provided on the
              Platform. The Participant shall pay a pre-booking fee of INR 49/-
              (Indian Rupees Fourty-Nine only) towards a desired Goal (as
              available at the time of registration) (“<b>Participation Fee</b>
              ”).
              <br />
              <br />
              Participants that register for the Program for a respective Goal
              shall be eligible for a discount of up to 50% (fifty percent) on
              the applicable subscription fee for the same Goal during the
              launch of the respective Goal. Unacademy may change or modify the
              Terms of the discount at its sole discretion.
              <br />
              <br />
              Participant(s) understand and acknowledge that the registration
              and payment towards the Program does not in any way amount to a
              subscription to the Goal at the time of launch and the Participant
              shall be required to visit the Platform and purchase the
              subscription to the Goal within the time periods provided herein.
              Unacademy shall launch the Goals at its sole discretion. In the
              event Unacademy does not launch a Goal that the Participant has
              registered to the respective Program, Unacademy shall refund the
              Participation Fee towards to the respective Participant.
              <br />
              <br />
              The discount towards the subscription to the Goal for the
              Participants, shall be valid for a period of 2 (weeks) from the
              date on which the particular Goal becomes active on the Platform.
              The Participant agrees and understands that there shall be no
              refund of the Participation Fee, in the event the Participant
              fails to avail the discounted subscription to the Goal
              on/before/within the above mentioned date/time period and
              accordingly, Unacademy shall not be required to refund the
              Participation Fee & the Participant will be required to pay the
              full price of the subscription for the Goal.
              <br />
              <br />
              The process and decision of launching the Goal(s) shall be subject
              to change, at the sole discretion of Unacademy and the decision of
              Unacademy shall be final and binding. The Participants are
              encouraged to check the Terms on a periodic basis to ensure that
              they do not miss out on any updates and modifications.
              <br />
              <br />
              Participant(s) understand that to confirm their eligibility they
              may be required to submit their information that may be requested
              by Unacademy at the time of registration.
              <br />
              <br />
              <ol type="i">
                <ListItem>
                  Unacademy shall only charge the participation fee for
                  registration to the Program on the Platform. Any other costs
                  towards the subscription to the Goal) shall be communicated on
                  the Platform during the launch.
                </ListItem>
                <ListItem>
                  Participants must exercise caution against any other person/
                  entity that demands money or its equivalent for the purpose of
                  participation in the Program and or the subscription to the
                  Goal. Unacademy shall not be liable to Participant for any
                  amount paid in this regard and Unacademy disclaims all
                  responsibilities in respect of the same.
                </ListItem>
              </ol>
            </Paragraph>
            <br />
            <br />
            <a name={tableData[1].id}>
              <StyledH3>{tableData[1].label}</StyledH3>
            </a>
            <Paragraph>
              A Participant’s Personal Information, including Sensitive Personal
              Information, that may be collected to enable such Participant to
              participate in the Program and enable rendering of Services (as
              defined in the <Link href="/terms">Terms and Conditions</Link>) by
              the Platform, shall be collected, processed, and stored in
              accordance with the Unacademy’s{' '}
              <Link href="/privacy">Privacy Policy</Link>. Participants shall
              have all the rights available to them under the applicable Data
              Protection Laws (
              <i>
                as defined in the <Link href="privacy">Privacy Policy</Link>
              </i>
              ) in accordance with the Unacademy Privacy Policy.
              <br />
              <br />
              Unacademy shall use a Participant’s Personal Information for
              facilitating this Program and rendering the Services with respect
              to the Platform in the most effective manner, to secure the
              Platform and make improvements, to perform market research and
              product analysis, to carry out Unacademy’s obligations towards the
              Participant, and to communicate with the Participant. The said
              communication can either be by calls, text, or emails and for the
              purposes which include transactional, service, advertising or
              promotional related calls or messages about the Program and other
              offers, new products or services made available by Unacademy, and
              the Participant hereby consents to the same.
              <br />
              <br />
              Any deletion request received from a Participant in respect of
              their Personal Information shall be processed in accordance with
              Unacademy Privacy Policy.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[2].id}>
              <StyledH3>{tableData[2].label}</StyledH3>
            </a>
            <Paragraph>
              The Participant hereby consents to the use by Unacademy of his/her
              name, age, photograph, videos, voice recordings, rank, statements
              and/or testimonials (“Personal Attributes”) for the purpose of
              publication, advertising, promotion on Unacademy’s online
              platforms, including but not limited to the Platform, and through
              any mode, medium, platform and/or format, including without
              limitation, in newspapers, magazines, other print media, on
              television, radio, internet and other electronic and/or in
              mailings for educational awareness.
              <br />
              <br />
              Any testimonial or statements provided by the Participant and any
              other details pertaining to their use of the Platform, content
              available of the Platform, shall be exclusively provided to
              Unacademy and the Participant warrants to that extent.
              <br />
              <br />
              The Participant hereby confirms that the chance provided by
              Unacademy to be recognized as a participant of the Program and/ or
              a rank-holder in the exams in accordance with these Program Terms,
              is sufficient consideration for the use of Participant’s Personal
              Attributes by Unacademy in accordance with the terms hereof, and
              Unacademy shall have no liability to pay any consideration for any
              use of the Participant’s Personal Attributes.
              <br />
              <br />
              The Participant shall release, waive, and discharge claims of any
              kind or nature arising out of or relating to the use of his/her
              Personal Attributes against Unacademy or any person or firm
              authorized by Unacademy to publish the same in accordance with the
              terms hereof. Such release, waiver and discharge shall also extend
              to all group companies, affiliated companies, subsidiaries,
              shareholders, directors, officers, employees, agents and assigns
              of Unacademy and any publishers of the Personal Attributes in
              accordance with the terms hereof. Such a release shall be binding
              on the Participant, his/her respective successors, heirs, assigns,
              executors, administrators, spouse and next of kin.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[3].id}>
              <StyledH3>{tableData[3].label}</StyledH3>
            </a>
            <ol type="i">
              <ListItem>
                Unacademy and/or its subsidiaries/affiliates shall not be under
                any obligation to the Participant in relation to the Program and
                the Participant shall have no claims whatsoever against
                Unacademy and/or its subsidiaries/affiliates relating to the
                selection process, gratification, or the running of the Program.
              </ListItem>
              <ListItem>
                Unacademy shall not be responsible for any errors or omissions
                in the Terms and conditions contained herein. All information
                provided is provided “as is” without warranty of any kind. To
                the fullest extent permitted by applicable law, Unacademy
                disclaims all warranties, express or implied, including without
                limitation, implied warranties of merchantability, fitness for a
                particular purpose, and non-infringement in respect of the
                Program.
              </ListItem>
              <ListItem>
                Unacademy shall have the sole discretion to discontinue/cancel
                the Program, cancel launch of any Goal(s), or any part thereof
                at any point in time and the Participant shall not raise any
                claim due to such discontinuation or cancellation at any time
                whatsoever.{' '}
              </ListItem>
              <ListItem>
                Unacademy shall not be held responsible in case of a server
                shutdown or loss of Participant’s registration and/or other
                data. Unacademy shall not be responsible for any delay in
                receipt or non-receipt or incomplete or corrupt receipt of the
                registration or, other details of the Participant. Unacademy
                shall not be responsible for any technical difficulties or data
                corruption that may arise during the registration process.
                Further, Unacademy shall not be responsible and/or liable in any
                manner whatsoever in case the Participant is unable to register
                for participation in the Program due to failure on part of the
                internet service provider, facility provider, etc.
              </ListItem>
            </ol>
            <br />
            <br />
            <a name={tableData[4].id}>
              <StyledH3>{tableData[4].label}</StyledH3>
            </a>
            <Paragraph>
              All other provisions not specifically stated herein, including
              without limitation, provisions pertaining to governing law and
              jurisdiction, indemnity and limitation of liability, shall apply
              to the Participants as is stated under the{' '}
              <Link href="/terms">Terms and Conditions</Link>, to the extent
              applicable.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[5].id}>
              <StyledH3>{tableData[5].label}</StyledH3>
            </a>
            <Paragraph>
              For any queries/concerns regarding these Program Terms and
              conditions, Participants may write to us by email at
              legal@unacademy.com or by post to:
            </Paragraph>
            <Paragraph>
              <b>Sorting Hat Technologies Pvt Ltd </b>
              <br />
              Maruthi Infotech Centre, 3rd Floor, <br />
              A-Block, Domlur, Koramangala Inner Ring Road, <br />
              Bangalore- 560 071, Karnataka, India.
            </Paragraph>
          </div>
        </Wrapper>
      </RightContainer>
    </>
  );
};

RankPredictorTerms.pageInfo = {
  name: 'Unacademy Rank Predictor Terms',
  isMWebSupported: true,
  layoutOptions: {
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

export default RankPredictorTerms;
RankPredictorTerms.Layout = Layout;
RankPredictorTerms.Wrapper = PageReduxProvider;
